export default {
  northern: '北部',
  central: '中部',
  southern: '西部',
  eastern: '東部',
  island: '離島',
  overseas: '海外',
  isRequired: '必填欄位',
  submitSuccess: '發送成功',
  detail: '進一步瞭解',
  partners: '合作夥伴',
  caseStudy: '產業結合案例',
  freeTrial: '免費試用申請',
  contactAndBuy: '與我們聯繫或直接購買',
  language: '語言',
  aboutUs: '關於我們',
  contactUs: '洽詢服務',
  submit: '送出',
  blockChainDiscovery: '探索區塊鏈各產業應用',
  blockChainBenefits: '區塊鏈產業應用特點',
  achieveMore: '應用所解決的產業問題',
  customerService: '聯繫客服',
  mailService: '信件洽詢',
  spotlight: '理念分享',
  page: {
    form: '表單'
  },
  status: {
    unread: '未讀',
    read: '已讀',
    solve: '已解決',
    update: '已更新',
    delete: '已刪除'
  },
  nav: {
    industries: '產業應用',
    contactUs: '聯繫我們'
  },
  hero: {
    title: '立即採用Owlting Blockchain Services™服務解決您的痛點',
    mobileTitle: ['立即採用Owlting Blockchain Services™服務', '解決您的痛點'],
    description: '無論您身處哪個產業，Owlting Blockchain Services™服務都能應用區塊鏈技術，建立更安全透明的商務流程，產出更值得客戶信賴的商品，打造具有高度信服力的商業服務'
  },
  form: {
    title: '請告訴我們您的需求與聯繫方式',
    companyName: '公司名稱',
    industry: '產業類別',
    name: '聯絡人',
    phone: '聯絡電話',
    email: '電子郵件',
    description: '需求/用途描述',
    plan: '專案',
    IOTs: 'IOTs'
  },
  banner: {
    title: '成為Owlting Blockchain Services™的合作夥伴',
    description: '立即註冊將有專人與您聯繫，為您打造客製化的Owlting Blockchain Services™服務'
  },
  cookie: {
    title: '奧丁丁使用隱私權聲明',
    content: '為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行。',
    more: '前往了解',
    agree: '確定'
  },
  custom: {
    forestry: {
      title: '行政院農委會林務局 x 奧丁丁Owlting Blockchain Services™ 林產品追溯系統',
      subTitle: '全球首創應用區塊鏈的林產品追溯系統正式上線！',
      content: '為提升合法國產材的市場並遏止盜伐，行政院農業委員會林務局結合區塊鏈技術，於 2019 年 12 月 5 日宣布推出「臺灣林產品生產追溯系統」，由奧丁丁集團協助開發，利用區塊鏈「可溯源」、「不可竄改」及「去中心化」的特性，記錄林產品生產歷程，保障合法業者及消費者權益，此舉更是領先各國，成為全球第一套以區塊鏈記錄國產木竹材生產歷程的溯源系統。',
      blockTitle: {
        product: '產品發表記者會',
        news: '媒體報導'
      }
    }
  },
  priceTable: {
    Agriculture: {
      projectPrice: '專案價格',
      tab01: '溯源履歷方案',
      tab02: '溯源履歷+IoT裝置方案',
      tab02Title: '溯源履歷+IoT裝置方案',
      monthlyLeasing: '*月租費用最短需綁訂合約1年',
      monthlyLeasingIOT: '*月租費用最短需綁訂合約1年，以此表為參考價格，卻切價格以實際報價單而定',
      annotation: '*此專案價格僅限台灣地區'
    }
  },
  cases: {
    riceValley: {
      name: '池上禾穀坊',
      intro: '給您安心的品牌',
      product: '無毒珍珠白米/糙米'
    },
    passionFruit: {
      name: '台東百香果',
      intro: '友善耕作無毒管理',
      product: '員崇果園無毒百香果'
    },
    oneForTea: {
      name: 'ONE for TEA 一凡茶作',
      intro: '台東鹿野無毒友善茶園',
      product: '紅烏龍茶/迎香包種茶'
    },
    changbinRice: {
      name: '龍岫良米',
      intro: '用心栽種，安心使用',
      product: '有機白米'
    },
    btn: '瀏覽產品履歷'
  },
  formLabel: {
    office_name: '公司名稱',
    contact_name: '聯絡人',
    contact_phone: '電話',
    contact_email: 'Email',
    industry: '產業類別',
    requirement: '需求',
    created_at: '建立時間'
  }
}
